/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {NzAvatarGroupComponent as ɵa} from './avatar-group.component';